module.exports = __webpack_public_path__ + "img/sec-c.33335d79.svg";